<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="d-flex mb-2 mt-0 justify-content-between align-items-start">
  <div class="nav nav-tabs no-select mb-0">
    @for (period of model?.periods; track $index) {
      <div class="nav-item ml-1 ml-sm-2 mr-sm-2">
        <a
          class="nav-link text-nowrap cursor-pointer font-medium"
          [class.active]="period.isActive"
          (click)="changeChartPeriod(period.value)"
          [ngbTooltip]="
            ('instrument-detail.instrument-chart.tooltip.' + period.value | transloco) ===
            'instrument-detail.instrument-chart.tooltip.' + period.value
              ? null
              : ('instrument-detail.instrument-chart.tooltip.' + period.value | transloco)
          "
        >
          {{ 'instrument-detail.instrument-chart.nav.' + period.value | transloco }}
          @if (period.value === 'CSI') {
            <web-design-system-pill type="new">{{ 'header.new-badge' | transloco }}</web-design-system-pill>
          }
        </a>
      </div>
    }
    @if (model?.displaySettings) {
      <charts-web-settings class="setting" [model]="model" (changeType)="chartService.changeChartType(model, $event)" />
    }
    <div class="d-block d-sm-none my-2">
      <ng-container *ngTemplateOutlet="proChart" />
    </div>
  </div>
  <div class="d-none d-sm-block">
    <ng-container *ngTemplateOutlet="proChart" />
  </div>
</div>

<ng-template #proChart>
  @if (!model.isOTC && model.instrumentType | equalsInstrumentType: [InstrumentType.Share, InstrumentType.Etf, InstrumentType.Funds]) {
    <div class="d-flex align-items-center justify-sm-content-end cursor-pointer gap-small" (click)="openProChart()">
      <div class="zero-text disabled font-medium pro-chart">ProChart</div>
      <web-design-system-icon class="zero-text disabled" size="medium" name="expand" />
    </div>
  }
</ng-template>

<div #chart class="chart-container mb-4" [style.height]="height() + 'px'" [style.display]="hideChart ? 'none' : null">
  @if (loading) {
    <charts-web-loading-indicator />
  }
</div>

@if (model?.displaySeriesToggles) {
  <div class="d-flex gap">
    <div class="select-button" [class.active]="model?.currentSeries | includes: 'bid'" (click)="toggleSerie('bid')">
      {{ 'instrument-detail.instrument-chart.serie-type.bid' | transloco }}
      <web-design-system-icon [name]="(model?.currentSeries | includes: 'bid') ? 'eye-2' : 'eye'" />
    </div>
    <div class="select-button" [class.active]="model?.currentSeries | includes: 'ask'" (click)="toggleSerie('ask')">
      {{ 'instrument-detail.instrument-chart.serie-type.ask' | transloco }}
      <web-design-system-icon [name]="(model?.currentSeries | includes: 'ask') ? 'eye-2' : 'eye'" />
    </div>
    <div class="select-button" [class.active]="model?.currentSeries | includes: 'last'" (click)="toggleSerie('last')">
      {{ 'instrument-detail.instrument-chart.serie-type.last' | transloco }}
      <web-design-system-icon [name]="(model?.currentSeries | includes: 'last') ? 'eye-2' : 'eye'" />
    </div>
  </div>
}

@if (hideChart) {
  <div class="chart-container">
    @if (model.hasError) {
      <div class="no-chart-info">
        <p
          [ngClass]="{
            'text-color-error': model.severity === 'error',
            'text-color-secondary': model.severity === 'info',
          }"
        >
          @if (model.errorMessage) {
            {{ model.errorMessage | transloco }}
          } @else {
            {{ 'instrument-detail.instrument-chart.error' | transloco }}
          }
        </p>
      </div>
    }
    @if (!loading && model.isLoaded && !model.hasError && model.series?.length === 0) {
      @if (model.isTradingTime) {
        <div class="no-chart-info">
          <p class="text-color-secondary">{{ 'instrument-detail.instrument-chart.no-chart' | transloco }}</p>
        </div>
      } @else {
        <div class="no-chart-info">
          <p class="text-color-secondary">{{ 'instrument-detail.instrument-chart.no-trading-time' | transloco }}</p>
        </div>
      }
    }
  </div>
}
